import { AnimatedComponent } from 'sane-ui'
import Flickity from 'flickity'
import { gsap, SplitText } from 'gsap/all'
import arrowShape from '../config/flickiyArrowShape.json'

class Testimonials extends AnimatedComponent {
  constructor ($el, args) {
    super($el, args)

    this.autoPlay = this.$el.data('autoPlay')
    const $items = this.$el.find('.testimonials__item')

    if ($items.length < 2) {
      return
    }

    this.flickity = new Flickity(
      $el.find('.testimonials__list').get(0),
      {
        pageDots: true,
        wrapAround: true,
        arrowShape,
        on: {
          ready: () => {
            if (this.timelineIn === undefined) {
              return
            }

            // Adds flickity parts animations to the timelineIn.
            this.timelineIn
              .addLabel('flickity', '-=0.4')
              .from(
                this.$el.find('.dot'),
                { duration: 0.4, opacity: 0, ease: 'none', stagger: 0.075 },
                'flickity'
              )
              .from(
                this.$el.find('.flickity-prev-next-button.next'),
                { duration: 0.4, opacity: 0, x: '-50%', ease: 'power2.out' },
                'flickity'
              )
              .from(
                this.$el.find('.flickity-prev-next-button.previous'),
                { duration: 0.4, opacity: 0, x: '50%', ease: 'power2.out' },
                'flickity'
              )
          },
          change: () => { this.scheduleAdvance() },
        },
      }
    )

    this.scrollCallback = this.scrollCallback.bind(this)
    this.flickity.on('scroll', this.scrollCallback)

    if (window.innerWidth < 768) {
      this.scheduleAdvance()
    }
  }

  scrollCallback () {
    this.flickity.slides.forEach((slide) => {
      const slideX = (slide.target + this.flickity.x) / slide.outerWidth
      const opacity = Math.min(Math.max(1 - Math.abs(slideX) * 2, 0), 1)
      gsap.set($(slide.cells[0].element), { opacity })
    })
  }

  buildTimelineIn () {
    const $firstItem = this.$el.find('.testimonials__item').first()
    const $copy = $firstItem.find('.testimonials__item__copy')
    const copyST = new SplitText($copy, { type: 'words' })
    const $authorName = $firstItem.find('.testimonials__item__author')
    const $authorDesc = $firstItem.find('.testimonials__item__author-description')

    this.timelineIn
      .set(this.$el, { autoAlpha: 1 })
      .from(
        copyST.words,
        { duration: 1.2, opacity: 0, ease: 'none', stagger: 0.01 }
      )
      .from(
        copyST.words,
        { duration: 0.6, y: '20%', ease: 'power2.out', stagger: 0.01 },
        0
      )
      .from(
        [$authorName, $authorDesc],
        { duration: 0.6, opacity: 0, y: '20%', ease: 'power2.out', stagger: 0.075 },
        0.6
      )
      .call(() => { this.scheduleAdvance() })
  }

  scheduleAdvance () {
    if (!this.autoPlay) {
      return
    }

    if (this.autoPlayTimeout !== undefined) {
      clearTimeout(this.autoPlayTimeout)
    }

    if (this.flickity !== null) {
      this.autoPlayTimeout = setTimeout(() => {
        this.flickity.next()
      }, this.autoPlay * 1000)
    }
  }

  destroy () {
    if (this.autoPlayTimeout !== undefined) {
      clearTimeout(this.autoPlayTimeout)
    }
  }
}

export default Testimonials



// WEBPACK FOOTER //
// ./scripts/components/Testimonials.js